module.exports = __webpack_public_path__ + "images/White Logo.png";